// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__4c4lC"};